import React from "react";
import { cn } from "../../lib/utils";

export function NavigationTabs({
  tabs = [
    { id: "loans", label: "Loans", path: "/borrower-portal/loans", active: true },
    {
      id: "draw-request",
      label: "Draw Request",
      path: "/draw-request/loans",
      active: false,
    },
  ],
  onTabClick,
  className = "",
  activeRoute = "/borrower-portal/loans",
}) {
  return (
    <nav
      className={`flex items-center space-x-8 relative ${className}`}
      role="navigation"
      aria-label="Main navigation"
    >
      {tabs.map((tab) => {
        const routeParts = activeRoute?.split("/") || [];
        const targetPart = routeParts.length > 1 ? routeParts[1] : "";
        const isActive = targetPart && tab?.path ? tab.path.includes(targetPart) : false;
        return (
          <NavItem
            key={tab?.id}
            label={tab?.label}
            isActive={isActive}
            onClick={() => {
              return onTabClick(tab);
            }}
          />
        );
      })}
    </nav>
  );
}

const NavItem = ({ label, isActive = false, onClick }) => {
  return (
    <button
      data-nav-item={label}
      onClick={onClick}
      aria-current={isActive ? "page" : undefined}
      className={cn(
        "text-sm font-medium transition-all duration-200 ease-in-out px-2 py-2 rounded-md relative",
        "hover:text-[#927940] hover:bg-[#faf7f2] focus:outline-none focus:ring-2 focus:ring-[#927940] focus:ring-opacity-50",
        isActive ? "text-[#927940]" : "text-gray-900"
      )}
    >
      {label}
      {isActive && (
        <div className="absolute -bottom-[1.1rem] left-0 right-0 h-[0.25rem] bg-[#927940]" />
      )}
    </button>
  );
};
